module.exports = __webpack_public_path__ + "img/智慧屏场景_美妆镜.1b4ece71.png";